module.exports = __webpack_public_path__ + "img/address-card-alt.be51e728.svg";